import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Inspection } from '../../../shared/models/index';

@Component({
    selector: 'addpoint-inspections',
    templateUrl: './inspection-list.component.html',
    standalone: false
})
export class AddPointInspectionListComponent {
  @Input() public inspections: Inspection[];
  @Output() public toggleSelectInspection: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}

  public selectInspection(inspection: Inspection) {
    this.toggleSelectInspection.emit(inspection);
  }
}
